import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, ChevronDown } from 'lucide-react';
export const Bonuses = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const bonuses = [{
    num: 1,
    title: 'Manual de adaptaciones para alumnas con limitaciones físicas',
    desc: 'Cómo modificar cada ejercicio para alumnas con problemas de rodilla, cadera, columna, tobillo y hombro. Incluye 20 fichas de ejercicios adaptados y frases para comunicar las modificaciones sin incomodar a tus alumnas.'
  }, {
    num: 2,
    title: 'Checklist de lanzamiento',
    desc: 'Todo lo que tenés que tener resuelto antes de abrir tu primera clase de barre: espacio, equipamiento, comunicación, inscripción y primera semana de clases.'
  }, {
    num: 3,
    title: 'Guión de clase modelo',
    desc: 'Una clase completa de 55 minutos detallada minuto a minuto, lista para replicar desde el día uno.'
  }, {
    num: 4,
    title: 'Kit de comunicación para redes',
    desc: 'Textos listos para stories, posts y respuestas a DMs para anunciar tu clase de barre y llenarla desde el lanzamiento.'
  }, {
    num: 5,
    title: 'Calculadora de rentabilidad',
    desc: 'Planilla Excel para proyectar ingresos, costos y punto de equilibrio según la cantidad de alumnas, el precio de clase y el modelo de cobro que elijas.'
  }];
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-gradient-to-b from-white to-[#F9F7FC]" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#EBE5F4] rounded-full mb-6" data-id="element-38">
            <Gift className="w-8 h-8 text-barre-purple" data-id="element-39" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-40">
            5 Bonos Exclusivos
          </h2>
          <div className="inline-block bg-barre-purple text-white px-6 py-2 rounded-full font-bold text-lg animate-pulse shadow-lg shadow-barre-purple/30" data-id="element-41">
            GRATIS SOLO POR HOY
          </div>
        </div>

        <div className="space-y-4" data-id="element-42">
          {bonuses.map((bonus, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className={`bg-white rounded-2xl shadow-md border-2 overflow-hidden transition-all duration-300 ${isOpen ? 'border-barre-purple ring-2 ring-barre-purple/20' : 'border-[#EBE5F4]'}`} data-id="element-43">
                <button onClick={() => toggle(index)} aria-expanded={isOpen} className={`w-full flex items-center gap-4 p-5 sm:p-6 text-left transition-colors ${isOpen ? 'bg-[#F9F7FC]' : 'hover:bg-[#F9F7FC]/50'}`} data-id="element-44">
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-45">
                    <Gift className={`w-5 h-5 ${isOpen ? 'text-barre-purple' : 'text-barre-lilac'}`} data-id="element-46" />
                    <span className={`text-sm font-bold uppercase tracking-wide ${isOpen ? 'text-barre-purple' : 'text-barre-lilac'}`} data-id="element-47">
                      Bono {bonus.num}
                    </span>
                  </div>
                  <h3 className="flex-1 text-base sm:text-lg font-bold text-gray-900 leading-tight" data-id="element-48">
                    {bonus.title}
                  </h3>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-barre-purple' : 'text-barre-lilac'}`} data-id="element-49" />
                </button>

                <AnimatePresence initial={false} data-id="element-50">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden bg-[#F9F7FC]/50" data-id="element-51">
                      <p className="px-5 sm:px-6 pb-6 pt-2 text-gray-700 font-medium leading-relaxed" data-id="element-52">
                        {bonus.desc}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};